// import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
// import clsx from "clsx";
// import MenuIcon from "@mui/icons-material/Menu";
// import AccountCircle from "@mui/icons-material/AccountCircle";
// import SummarizeIcon from "@mui/icons-material/Summarize";
// import DvrIcon from "@mui/icons-material/Dvr";
// import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
// import FlagCircleIcon from "@mui/icons-material/FlagCircle";
// import AccountBoxIcon from "@mui/icons-material/AccountBox";
// import AutoAwesomeMosaicIcon from "@mui/icons-material/AutoAwesomeMosaic";
// import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
// import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import FactCheckIcon from "@mui/icons-material/FactCheck";
// import {
//   List,
//   ListItem,
//   ListItemText,
//   // Menu,
//   // MenuItem,
//   // IconButton,
//   Typography,
//   Toolbar,
//   AppBar,
//   Drawer,
// } from "@material-ui/core";
// import {
//   Button,
//   ListItemButton,
//   ListItemIcon,
//   Menu,
//   MenuItem,
//   SubMenu,
//   Tooltip,
// } from "@mui/material";

// //import "react-pro-sidebar/dist/css/styles.css";
// import {
//   Work,
//   Home,
//   ShoppingCart,
//   LogoutOutlined,
//   Hail,
//   ConfirmationNumber,
//   Group,
//   Groups,
//   Person,
//   InboxOutlined,
//   StarBorder,
//   ConfirmationNumberOutlined,
//   TrendingUp,
//   CalendarMonth,
//   DensityMedium,
//   Handshake,
//   Payments,
//   Task,
//   PersonOutlined,
//   AccessTime,
//   ExitToApp,
//   OfflinePin,
//   CalendarMonthOutlined,
//   DockOutlined,
//   RequestPage,
//   RequestQuote,
//   RestorePageOutlined,
// } from "@mui/icons-material";
// import { Link, useLocation } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { logout } from "../actions/auth";
// import WorkspacesIcon from "@mui/icons-material/Workspaces";
// // import ViewTimelineIcon from "@mui/icons-material/ViewTimeline";
// import StorefrontIcon from "@mui/icons-material/Storefront";
// import drawerImage from "../images/sidebar-bg.png";
// import IconButton from "@mui/material/IconButton";
// import CssBaseline from "@material-ui/core/CssBaseline";
// import Divider from "@material-ui/core/Divider";
// import Container from "@material-ui/core/Container";
// import Grid from "@material-ui/core/Grid";
// import { CustomerList } from "../pages/customers";
// import { useState } from "react";

// //import { StarBorder, InboxIcon } from "@mui/icons-material";

// import Collapse from "@material-ui/core/Collapse";
// import { ExpandLess } from "@mui/icons-material";
// import { ExpandMore } from "@mui/icons-material";
// import { useEffect } from "react";
// import CategoryIcon from "@mui/icons-material/Category";
// //import Collapse from "@mui/material";
// const drawerWidth = 240;

// const useStyles = makeStyles((theme) => ({
//   root: {
//     display: "flex",
//     height: "100vh",
//     overflow: "auto",
//     color: "#000133",
//   },
//   toolbar: {
//     paddingRight: 24, // keep right padding when drawer closed
//     minHeight: 45,
//   },
//   icon: {
//     padding: "10px",
//   },
//   toolbarIcon: {
//     // minHeight: "45px !important",
//     // display: "flex",
//     // alignItems: "center",
//     // justifyContent: "flex-end",
//     // padding: "0 8px",

//     ...theme.mixins.toolbar,
//   },
//   appBar: {
//     zIndex: theme.zIndex.drawer + 1,
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.leavingScreen,
//     }),
//     background: "#FFF",
//     // backgroundColor: "#0e1832",
//     color: "#101728",
//     boxShadow: "0px 0px 8px #e1e1e1",
//   },
//   appBarShift: {
//     marginLeft: drawerWidth,
//     width: `calc(100% - ${drawerWidth}px)`,
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   },
//   menuButton: {
//     marginRight: 36,
//     "&:hover": {
//       backgroundColor: "#0e1832",
//       color: "#fff",
//       borderRadius: "4px",
//     },
//   },
//   button: {
//     "&:hover": {
//       backgroundColor: "#273557",
//       color: "#fff",
//       borderRadius: "4px",
//     },
//   },
//   menuButtonHidden: {
//     display: "none",
//   },
//   title: {
//     // marginRight: "auto",
//     flexGrow: 1,
//     fontSize: "18px",
//     color: "#ffffff",
//     fontWeight: 700,
//     fontFamily: "Roboto",
//   },
//   drawerPaper: {
//     color: "#fff",
//     //background: "#101728",
//     backgroundColor: "#0e1832",
//     //position: "static",
//     transition: "width .2s",
//     border: "none",
//     backgroundImage: `url(${drawerImage})`,
//     backgroundSize: "cover",
//     backgroundPosition: "center center",
//     position: "relative",
//     whiteSpace: "nowrap",
//     width: drawerWidth,
//     transition: theme.transitions.create("width", {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   },
//   drawerPaperClose: {
//     overflowX: "hidden",
//     transition: theme.transitions.create("width", {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.leavingScreen,
//     }),
//     width: theme.spacing(8),
//     [theme.breakpoints.up("sm")]: {
//       width: theme.spacing(6.7),
//     },
//   },
//   appBarSpacer: theme.mixins.toolbar,
//   content: {
//     // content which is class of main needs to be flex and column direction
//     display: "flex",
//     flexDirection: "column",
//     flexGrow: 1,
//     height: "100vh",
//     overflow: "auto",
//     background: "#eeeeee",
//   },
//   container: {
//     paddingTop: theme.spacing(4),
//     paddingBottom: theme.spacing(4),
//   },
//   paper: {
//     padding: theme.spacing(2),
//     display: "flex",
//     overflow: "auto",
//     flexDirection: "column",
//   },
//   fixedHeight: {
//     height: 240,
//   },
//   // added the footer class
//   footer: {
//     padding: theme.spacing(2),
//     marginTop: "auto",
//     //backgroundColor: "white",
//     // just this item, push to bottom
//     alignSelf: "flex-end",
//     background: "#00022E",
//     height: "50px",
//     color: "#FC86AA",
//   },
//   IconColor: {
//     // background: "#00022E",
//     // height: "50px",
//     color: "#FFF",
//   },
//   listItem: {
//     //paddingRight: 0,
//     // paddingTop: 0,
//     padding: 0,
//   },
//   container: {
//     display: "flex",
//     flex: 1,
//   },
//   listText: {
//     // width: '200px',
//     overflow: "hidden",
//     background: "#fff",
//   },
//   main: {
//     flex: 1,
//     background: "#f1f5fa",
//     color: "black",
//     height: "93vh",
//     overflowY: "scroll",
//   },
//   logoutButton: {
//     marginLeft: "auto !important",
//     backgroundImage:
//       "linear-gradient(90deg, #08459c 0%, #2a95f7 100%) !important",
//     color: "#fff !important",
//     minWidth: "42px",
//   },
// }));

// export default function Layout({ children }) {
//   const classes = useStyles();
//   const user = useSelector((state) => state.user);
//   const { pathname } = useLocation();

//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const toggleDrawer = () => {
//     setDrawerOpen((prev) => !prev);
//   };

//   // const [open, setOpen] = React.useState(true);
//   // const [close, setClose] = React.useState(false);
//   // const handleDrawerOpen = () => {
//   //   setOpen(true);
//   //   setClose(false);
//   // };
//   // const handleDrawerClose = () => {
//   //   setOpen(false);
//   //   setClose(true);
//   // };
//   const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
//   const dispatch = useDispatch();
//   const handleLogout = () => {
//     dispatch(logout());
//   };
//   const checkUser = user.role;

//   return (
//     <div className={classes.root}>
//       <CssBaseline />
//       <AppBar
//         position="absolute"
//         className={clsx(
//           classes.appBar,
//           drawerOpen && classes.appBarShift,
//           drawerOpen && classes.appBarShift
//         )}
//       >
//         <Toolbar className={classes.toolbar}>
//           <IconButton
//             edge="start"
//             color="inherit"
//             aria-label="open drawer"
//             onClick={toggleDrawer}
//             className={clsx(
//               classes.menuButton
//               // drawerOpen && classes.menuButtonHidden
//             )}
//           >
//             <MenuIcon />
//           </IconButton>

//           <Button
//             className={classes.logoutButton}
//             variant="contained"
//             onClick={handleLogout}
//             title="Logout"
//           >
//             <LogoutOutlined color="#fff" />
//           </Button>
//         </Toolbar>
//       </AppBar>
//       <Drawer
//         variant="permanent"
//         classes={{
//           paper: clsx(
//             classes.drawerPaper,
//             !drawerOpen && classes.drawerPaperClose,
//             !drawerOpen && classes.drawerPaperClose
//           ),
//         }}
//         open={drawerOpen}
//       >
//         <Toolbar className="toolbarIcon">
//           <Typography variant="h6" className={classes.title}>
//             {/* Project Management */}
//           </Typography>
//         </Toolbar>
//         <Divider />
//         <List>
//           <>
//             <CustomCheck type={user.role}></CustomCheck>
//           </>
//         </List>
//       </Drawer>
//       <main className={classes.content}>
//         <div className={classes.appBarSpacer} />
//         <Container
//           maxWidth="lg"
//           // className={classes.container}
//           className="pmt-container"
//         >
//           <Grid container spacing={0}>
//             {children}
//           </Grid>
//         </Container>
//       </main>
//     </div>
//   );
// }
// function CustomListItem({ icon, text, to, active = false }) {
//   const classes = useStyles();

//   return (
//     <Link to={to}>
//       <ListItem className={classes.listItem}>
//         <ListItemButton
//           className={classes.button}
//           sx={{
//             pr: 1,
//             pl: 1,
//             // backgroundColor: active ? "#d81b60" : "inherit",
//             backgroundImage: active
//               ? "linear-gradient(90deg, #08459c 0%, #2a95f7 100%)"
//               : "inherit",

//             borderRadius: "6px",
//             // marginRight: "14px",
//           }}
//         >
//           <ListItemIcon sx={{ minWidth: "40px" }}>{icon}</ListItemIcon>
//           <ListItemText primary={text} />
//         </ListItemButton>
//       </ListItem>
//     </Link>
//   );
// }

// function CustomCheck({ type }) {
//   const classes = useStyles();
//   const { pathname } = useLocation();
//   const user = useSelector((state) => state.user);
//   useEffect(() => {}, [user]);
//   /*----dropdown----*/
//   const [open, setOpen] = useState(false);
//   const [ticketing, setTicketing] = useState(false);
//   const [projectManagement, setProjectMangement] = useState(false);
//   const [hRMManagement, setHRMMangement] = useState(false);
//   const [assetManagement, setAssetMangement] = useState(false);
//   useEffect(() => {
//     compareDate();
//   }, [user.lock_in_date, new Date()]);

//   function compareDate() {
//     if (!user || !user.lock_in_date) {
//       return false;
//     } else {
//       const argumentDate = new Date(user.lock_in_date.substring(0, 10));
//       const currentDate = new Date();
//       argumentDate.setHours(0, 0, 0, 0);
//       currentDate.setHours(0, 0, 0, 0);
//       console.log(currentDate, argumentDate);
//       console.log(currentDate >= argumentDate);
//       return currentDate >= argumentDate; // Adjusted comparison operator
//     }
//   }

//   const handleClick = () => {
//     setOpen(!open);
//   };
//   const handleTicketingClick = () => {
//     setTicketing(!ticketing);
//   };
//   const handleProjectClick = () => {
//     setProjectMangement(!projectManagement);
//   };
//   const handleHRMClick = () => {
//     setHRMMangement(!hRMManagement);
//   };
//   const handleAssetClick = () => {
//     setAssetMangement(!assetManagement);
//   };
//   /*----dropdown end----*/
//   switch (type) {
//     case "Trial_User":
//       return (
//         <>
//           <ListItemButton
//             onClick={handleTicketingClick}
//             className="dropdown-nav"
//           >
//             <ListItemIcon className="icon-min-width">
//               <ConfirmationNumber />
//             </ListItemIcon>
//             <ListItemText primary="Ticketing" />
//             {ticketing ? <ExpandLess /> : <ExpandMore />}
//           </ListItemButton>
//           <Collapse
//             in={ticketing}
//             timeout="auto"
//             unmountOnExit
//             className="dropdown-nav-list"
//           >
//             <List component="div" disablePadding>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/"
//                   text="Dashboard"
//                   icon={<Home className={classes.IconColor} />}
//                   active={pathname === "/"}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/ticket"
//                   text="Tickets"
//                   icon={<ConfirmationNumber className={classes.IconColor} />}
//                   active={pathname.startsWith("/ticket")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/reports"
//                   text="Reports"
//                   icon={<SummarizeIcon className={classes.IconColor} />}
//                   active={pathname === "/reports"}
//                 />
//               </ListItemButton>
//             </List>
//           </Collapse>
//           <ListItemButton onClick={handleProjectClick} className="dropdown-nav">
//             <ListItemIcon className="icon-min-width">
//               <Work />
//             </ListItemIcon>
//             <ListItemText primary="Project Management" />
//             {projectManagement ? <ExpandLess /> : <ExpandMore />}
//           </ListItemButton>
//           <Collapse
//             in={projectManagement}
//             timeout="auto"
//             unmountOnExit
//             className="dropdown-nav-list"
//           >
//             <List component="div" disablePadding>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/timesheet"
//                   text="Timesheet"
//                   icon={<Task className={classes.IconColor} />}
//                   active={pathname.startsWith("/timesheet")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/projects"
//                   text="Projects"
//                   icon={<Work className={classes.IconColor} />}
//                   active={pathname === "/projects"}
//                   //active={pathname.startsWith("/projects")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/project-Activities"
//                   text="Project-Activities"
//                   icon={<AccessTime className={classes.IconColor} />}
//                   active={pathname === "/project-Activities"}
//                   //active={pathname.startsWith("/projects-Activities")}
//                 />
//               </ListItemButton>

//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/purchase-orders"
//                   text="Purchase Orders"
//                   icon={<ShoppingCart className={classes.IconColor} />}
//                   active={pathname.startsWith("/purchase-orders")}
//                 />
//               </ListItemButton>
//             </List>
//           </Collapse>
//           <CustomListItem
//             to="/crmLeads"
//             text="CRM"
//             icon={<ConfirmationNumber className={classes.IconColor} />}
//             active={pathname.startsWith("/crmLeads")}
//           />
//           <CustomListItem
//             to="/customer"
//             text="Customers"
//             icon={<Hail className={classes.IconColor} />}
//             active={pathname.startsWith("/customer")}
//           />

//           <CustomListItem
//             to="/employees"
//             text="Employees"
//             icon={<WorkspacesIcon className={classes.IconColor} />}
//             active={pathname.startsWith("/employees")}
//           />
//           <CustomListItem
//             to="/vendor"
//             text="Vendors"
//             icon={<StorefrontIcon className={classes.IconColor} />}
//             active={pathname.startsWith("/vendor")}
//           />

//           <CustomListItem
//             to="/profile"
//             text="Profile"
//             icon={<AccountCircle className={classes.IconColor} />}
//             active={pathname === "/profile"}
//           />
//           <CustomListItem
//             to="/resignation"
//             text="Exit Process"
//             icon={<AssignmentIndIcon className={classes.IconColor} />}
//             active={pathname === "/resignation"}
//           />
//           {user.appraisal_id && (
//             <CustomListItem
//               to="/my-appraisal"
//               text="My Appraisal"
//               icon={<FactCheckIcon className={classes.IconColor} />}
//               active={pathname === "/my-appraisal"}
//             />
//           )}
//         </>
//       );
//     case "Admin":
//       return (
//         <>
//           {/* <CustomListItem
//             to="/"
//             text="Dashboard"
//             icon={<Home className={classes.IconColor} />}
//             active={pathname === "/"}
//           /> */}

//           {/* <ListItemButton onClick={handleClick} className="dropdown-nav">
//             <ListItemIcon className="icon-min-width">
//               <Handshake />
//             </ListItemIcon>
//             <ListItemText primary="Partner - Portal" />
//             {open ? <ExpandLess /> : <ExpandMore />}
//           </ListItemButton> */}
//           {/* <Collapse
//             in={open}
//             timeout="auto"
//             unmountOnExit
//             className="dropdown-nav-list"
//           >
//             <List component="div" disablePadding>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/partners"
//                   text="Partner List"
//                   icon={<PersonOutlined className={classes.IconColor} />}
//                   active={pathname.startsWith("/partners")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/commissions"
//                   text="Commissions"
//                   icon={<Payments className={classes.IconColor} />}
//                   active={pathname.startsWith("/commissions")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/sales"
//                   text="sales"
//                   icon={<TrendingUp className={classes.IconColor} />}
//                   active={pathname.startsWith("/sales")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/leads"
//                   text="leads"
//                   icon={<DensityMedium className={classes.IconColor} />}
//                   active={pathname.startsWith("/leads")}
//                 />
//               </ListItemButton>
//             </List>
//           </Collapse> */}
//           <ListItemButton
//             onClick={handleTicketingClick}
//             className="dropdown-nav"
//           >
//             <ListItemIcon className="icon-min-width">
//               <ConfirmationNumber />
//             </ListItemIcon>
//             <ListItemText primary="Ticketing" />
//             {ticketing ? <ExpandLess /> : <ExpandMore />}
//           </ListItemButton>
//           <Collapse
//             in={ticketing}
//             timeout="auto"
//             unmountOnExit
//             className="dropdown-nav-list"
//           >
//             <List component="div" disablePadding>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/"
//                   text="Dashboard"
//                   icon={<Home className={classes.IconColor} />}
//                   active={pathname === "/"}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/ticket"
//                   text="Tickets"
//                   icon={<ConfirmationNumber className={classes.IconColor} />}
//                   active={pathname.startsWith("/ticket")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/reports"
//                   text="Reports"
//                   icon={<SummarizeIcon className={classes.IconColor} />}
//                   active={pathname === "/reports"}
//                 />
//               </ListItemButton>
//             </List>
//           </Collapse>
//           <ListItemButton onClick={handleProjectClick} className="dropdown-nav">
//             <ListItemIcon className="icon-min-width">
//               <Work />
//             </ListItemIcon>
//             <ListItemText primary="Project Management" />
//             {projectManagement ? <ExpandLess /> : <ExpandMore />}
//           </ListItemButton>
//           <Collapse
//             in={projectManagement}
//             timeout="auto"
//             unmountOnExit
//             className="dropdown-nav-list"
//           >
//             <List component="div" disablePadding>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/timesheet"
//                   text="Timesheet"
//                   icon={<Task className={classes.IconColor} />}
//                   active={pathname.startsWith("/timesheet")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/projects"
//                   text="Projects"
//                   icon={<Work className={classes.IconColor} />}
//                   active={pathname === "/projects"}
//                   //active={pathname.startsWith("/projects")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/project-Activities"
//                   text="Project-Activities"
//                   icon={<AccessTime className={classes.IconColor} />}
//                   active={pathname === "/project-Activities"}
//                   //active={pathname.startsWith("/projects-Activities")}
//                 />
//               </ListItemButton>

//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/purchase-orders"
//                   text="Purchase Orders"
//                   icon={<ShoppingCart className={classes.IconColor} />}
//                   active={pathname.startsWith("/purchase-orders")}
//                 />
//               </ListItemButton>
//             </List>
//           </Collapse>
//           <ListItemButton
//             onClick={handleHRMClick}
//             className={classes.dropdownNav}
//           >
//             <ListItemIcon className="icon-min-width">
//               <Tooltip title="HRM" placement="right-start">
//                 <ExitToApp />
//               </Tooltip>
//             </ListItemIcon>
//             <ListItemText primary="HRMS" />
//             {hRMManagement ? <ExpandLess /> : <ExpandMore />}
//           </ListItemButton>

//           <Collapse
//             in={hRMManagement}
//             timeout="auto"
//             unmountOnExit
//             className="dropdown-nav-list"
//           >
//             <List component="div" disablePadding>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/working-status"
//                   text="Working Status"
//                   icon={
//                     <Tooltip title="Attendance" placement="right-start">
//                       <CategoryIcon className={classes.IconColor} />
//                     </Tooltip>
//                   }
//                   active={pathname.startsWith("/working-status")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/my-leaves"
//                   text="My Leaves"
//                   icon={
//                     <Tooltip title="Leaves" placement="right-start">
//                       <OfflinePin className={classes.IconColor} />
//                     </Tooltip>
//                   }
//                   active={pathname.startsWith("my-leaves")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/team-leaves"
//                   text="Team Leaves"
//                   icon={
//                     <Tooltip title="Leaves" placement="right-start">
//                       <DockOutlined className={classes.IconColor} />
//                     </Tooltip>
//                   }
//                   active={pathname.startsWith("team-leaves")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/holidays"
//                   text="Holidays"
//                   icon={
//                     <Tooltip title="Holidays" placement="right-start">
//                       <CalendarMonthOutlined className={classes.IconColor} />
//                     </Tooltip>
//                   }
//                   active={pathname.startsWith("holidays")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/resignation-request"
//                   text="Resignation Request"
//                   icon={
//                     <Tooltip
//                       title="Resignation Request"
//                       placement="right-start"
//                     >
//                       <RestorePageOutlined className={classes.IconColor} />
//                     </Tooltip>
//                   }
//                   active={pathname.startsWith("resignation-request")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/appraisal"
//                   text="Appraisals"
//                   icon={
                    
//                     <Tooltip title="Appraisals" placement="right-start">
//                       <ThumbUpIcon className={classes.IconColor} />
//                     </Tooltip>
//                   }
//                   active={pathname.startsWith("appraisal")}
//                 />
//               </ListItemButton>
//               {/* <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/resignation-checklist"
//                   text="Resignation Checklist"
//                   icon={
//                     <Tooltip title="Resignation Accept" placement="right-start">
//                       <RestorePageOutlined className={classes.IconColor} />
//                     </Tooltip>
//                   }
//                   active={pathname.startsWith("resignation-checklist")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/assets-checklist"
//                   text="Assets Checklist"
//                   icon={
//                     <Tooltip title="Assets Checklist" placement="right-start">
//                       <DevicesOtherIcon className={classes.IconColor} />
//                     </Tooltip>
//                   }
//                   active={pathname.startsWith("assets-checklist")}
//                 />
//               </ListItemButton> */}
//               {/* <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/FNF-process"
//                   text="FNF-Process"
//                   icon={
//                     <Tooltip title="FNF Process" placement="right-start">
//                       <DescriptionIcon className={classes.IconColor} />
//                     </Tooltip>
//                   }
//                   active={pathname.startsWith("FNF-Process")}
//                 />
//  </ListItemButton> */}

//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/Payslip-list"
//                   text="PaySlip"
//                   icon={
//                     <Tooltip title="PaySlip" placement="right-start">
//                       <LibraryBooksIcon className={classes.IconColor} />
//                     </Tooltip>
//                   }
//                   active={pathname.startsWith("Pay-slip-list")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/KRA-List"
//                   text="KRA Goals"
//                   icon={
//                     <Tooltip title="KRA Goals" placement="right-start">
//                       <FlagCircleIcon className={classes.IconColor} />
//                     </Tooltip>
//                   }
//                   active={pathname.startsWith("Kra-list")}
//                 />
//               </ListItemButton>
//             </List>
//           </Collapse>
//           <ListItemButton
//             onClick={handleAssetClick}
//             className={classes.dropdownNav}
//           >
//             <ListItemIcon className="icon-min-width">
//               <Tooltip title="Asset Management" placement="right-start">
//                 <DvrIcon />
//               </Tooltip>
//             </ListItemIcon>
//             <ListItemText primary="Asset Management" />
//             {assetManagement ? <ExpandLess /> : <ExpandMore />}
//           </ListItemButton>

//           <Collapse
//             in={assetManagement}
//             timeout="auto"
//             unmountOnExit
//             className="dropdown-nav-list"
//           >
//             <List component="div" disablePadding>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/asset"
//                   text="Assets"
//                   icon={
//                     <Tooltip title="Asset" placement="right-start">
//                       <CategoryIcon className={classes.IconColor} />
//                     </Tooltip>
//                   }
//                   active={pathname.startsWith("/asset")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/category"
//                   text="Asset-Category"
//                   icon={
//                     <Tooltip title="Category" placement="right-start">
//                       <AutoAwesomeMosaicIcon className={classes.IconColor} />
//                     </Tooltip>
//                   }
//                   active={pathname.startsWith("/category")}
//                 />
//               </ListItemButton>
//             </List>
//           </Collapse>
//           <CustomListItem
//             to="/crmLeads"
//             text="CRM"
//             icon={<ConfirmationNumber className={classes.IconColor} />}
//             active={pathname.startsWith("/crmLeads")}
//           />
//           <CustomListItem
//             to="/customer"
//             text="Customers"
//             icon={<Hail className={classes.IconColor} />}
//             active={pathname.startsWith("/customer")}
//           />

//           <CustomListItem
//             to="/employees"
//             text="Employees"
//             icon={<WorkspacesIcon className={classes.IconColor} />}
//             active={pathname.startsWith("/employees")}
//           />
//           <CustomListItem
//             to="/vendor"
//             text="Vendors"
//             icon={<StorefrontIcon className={classes.IconColor} />}
//             active={pathname.startsWith("/vendor")}
//           />
//           <CustomListItem
//             to="/trial-users"
//             text="Trial Users"
//             icon={<AccountCircle className={classes.IconColor} />}
//             active={pathname === "/trial-users"}
//           />
//           <CustomListItem
//             to="/profile"
//             text="Profile"
//             icon={<AccountCircle className={classes.IconColor} />}
//             active={pathname === "/profile"}
//           />

//           <CustomListItem
//             to="/resignation"
//             text="Exit Process"
//             icon={<AssignmentIndIcon className={classes.IconColor} />}
//             active={pathname === "/resignation"}
//           />
//           {user.appraisal_id && (
//             <CustomListItem
//               to="/my-appraisal"
//               text="My Appraisal"
//               icon={<FactCheckIcon className={classes.IconColor} />}
//               active={pathname === "/my-appraisal"}
//             />
//           )}
//         </>
//       );

//     case "Partner":
//       return (
//         <>
//           <CustomListItem
//             to="/profile"
//             text="Profile"
//             icon={<AccountCircle className={classes.IconColor} />}
//             active={pathname === "/profile"}
//           />
//           {user.agreement_status === "verified" ? (
//             <ListItemButton onClick={handleClick} className="dropdown-nav">
//               <ListItemIcon className="icon-min-width">
//                 <Handshake />
//               </ListItemIcon>
//               <ListItemText primary="Partner" />
//               {open ? <ExpandLess /> : <ExpandMore />}
//             </ListItemButton>
//           ) : user.agreement_status === "accept" ? (
//             <CustomListItem
//               to="/downloadUploadAgreement"
//               text="Partner"
//               icon={<ConfirmationNumber className={classes.IconColor} />}
//               active={pathname.startsWith("/downloadUploadAgreement")}
//             />
//           ) : (
//             <CustomListItem
//               to="/termsandconditions"
//               text="Partner"
//               icon={<ConfirmationNumber className={classes.IconColor} />}
//               active={pathname.startsWith("/termsandconditions")}
//             />
//           )}
//           <Collapse
//             in={open}
//             timeout="auto"
//             unmountOnExit
//             className="dropdown-nav-list"
//           >
//             <List component="div" disablePadding>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/leads"
//                   text="leads"
//                   icon={<DensityMedium className={classes.IconColor} />}
//                   active={pathname.startsWith("/leads")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/followup"
//                   text="Follow-up"
//                   icon={<CalendarMonth className={classes.IconColor} />}
//                   active={pathname.startsWith("/followup")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/sales"
//                   text="Sales"
//                   icon={<TrendingUp className={classes.IconColor} />}
//                   active={pathname.startsWith("/sales")}
//                 />
//               </ListItemButton>
//             </List>
//           </Collapse>
//         </>
//       );
//     case "User":
//       return (
//         <>
//           <CustomListItem
//             to="/timesheet"
//             text="Timesheet"
//             icon={<Task className={classes.IconColor} />}
//             active={pathname.startsWith("/timesheet")}
//           />
//           <CustomListItem
//             to="/ticket"
//             text="Tickets"
//             icon={<ConfirmationNumber className={classes.IconColor} />}
//             active={pathname.startsWith("/ticket")}
//           />
//           <ListItemButton
//             onClick={handleHRMClick}
//             className={classes.dropdownNav}
//           >
//             <ListItemIcon className="icon-min-width">
//               <Tooltip title="HRM" placement="right-start">
//                 <ExitToApp />
//               </Tooltip>
//             </ListItemIcon>
//             <ListItemText primary="HRMS" />
//             {hRMManagement ? <ExpandLess /> : <ExpandMore />}
//           </ListItemButton>

//           <Collapse
//             in={hRMManagement}
//             timeout="auto"
//             unmountOnExit
//             className="dropdown-nav-list"
//           >
//             <List component="div" disablePadding>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/my-leaves"
//                   text="My Leaves"
//                   icon={
//                     <Tooltip title="Leaves" placement="right-start">
//                       <OfflinePin className={classes.IconColor} />
//                     </Tooltip>
//                   }
//                   active={pathname.startsWith("my-leaves")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/holidays"
//                   text="Holidays"
//                   icon={
//                     <Tooltip title="Holidays" placement="right-start">
//                       <CalendarMonthOutlined className={classes.IconColor} />
//                     </Tooltip>
//                   }
//                   active={pathname.startsWith("holidays")}
//                 />
//               </ListItemButton>
//             </List>
//           </Collapse>
//           <CustomListItem
//             to="/profile"
//             text="Profile"
//             icon={<AccountCircle className={classes.IconColor} />}
//             active={pathname === "/profile"}
//           />
//           {compareDate() === true &&
//           user.resignation_initiated === false &&
//           user.lock_in_date !== null ? (
//             <CustomListItem
//               to="/resignation"
//               text="Exit Process"
//               icon={<AssignmentIndIcon className={classes.IconColor} />}
//               active={pathname === "/resignation"}
//             />
//           ) : (
//             <></>
//           )}
//           {user.lock_in_date === null ? (
//             <CustomListItem
//               to="/resignation"
//               text="Exit Process"
//               icon={<AssignmentIndIcon className={classes.IconColor} />}
//               active={pathname === "/resignation"}
//             />
//           ) : (
//             <></>
//           )}
//           {user.appraisal_id && (
//             <CustomListItem
//               to="/my-appraisal"
//               text="My Appraisal"
//               icon={<FactCheckIcon className={classes.IconColor} />}
//               active={pathname === "/my-appraisal"}
//             />
//           )}
//         </>
//       );
//     case "Support":
//       return (
//         <>
//           <CustomListItem
//             to="/"
//             text="Dashboard"
//             icon={<Home className={classes.IconColor} />}
//             active={pathname === "/"}
//           />
//           <CustomListItem
//             to="/ticket"
//             text="Tickets"
//             icon={<ConfirmationNumber className={classes.IconColor} />}
//             active={pathname.startsWith("/ticket")}
//           />
//           <CustomListItem
//             to="/customer"
//             text="Customers"
//             icon={<Person className={classes.IconColor} />}
//             active={pathname.startsWith("/customer")}
//           />

//           <CustomListItem
//             to="/profile"
//             text="Profile"
//             icon={<AccountCircle className={classes.IconColor} />}
//             active={pathname === "/profile"}
//           />
//           <CustomListItem
//             to="/reports"
//             text="Reports"
//             icon={<SummarizeIcon className={classes.IconColor} />}
//             active={pathname === "/reports"}
//           />
//         </>
//       );
//     case "ReportingManager":
//       return (
//         <>
//           <CustomListItem
//             to="/"
//             text="Dashboard"
//             icon={<Home className={classes.IconColor} />}
//             active={pathname === "/"}
//           />
//           <CustomListItem
//             to="/timesheet"
//             text="Timesheet"
//             icon={<Task className={classes.IconColor} />}
//             active={pathname.startsWith("/timesheet")}
//           />
//           <CustomListItem
//             to="/ticket"
//             text="Tickets"
//             icon={<ConfirmationNumber className={classes.IconColor} />}
//             active={pathname.startsWith("/ticket")}
//           />
//           <ListItemButton
//             onClick={handleHRMClick}
//             className={classes.dropdownNav}
//           >
//             <ListItemIcon className="icon-min-width">
//               <Tooltip title="HRM" placement="right-start">
//                 <ExitToApp />
//               </Tooltip>
//             </ListItemIcon>
//             <ListItemText primary="HRMS" />
//             {hRMManagement ? <ExpandLess /> : <ExpandMore />}
//           </ListItemButton>

//           <Collapse
//             in={hRMManagement}
//             timeout="auto"
//             unmountOnExit
//             className="dropdown-nav-list"
//           >
//             <List component="div" disablePadding>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/working-status"
//                   text="Working Status"
//                   icon={
//                     <Tooltip title="Attendance" placement="right-start">
//                       <CategoryIcon className={classes.IconColor} />
//                     </Tooltip>
//                   }
//                   active={pathname.startsWith("/working-status")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/my-leaves"
//                   text="My Leaves"
//                   icon={
//                     <Tooltip title="Leaves" placement="right-start">
//                       <OfflinePin className={classes.IconColor} />
//                     </Tooltip>
//                   }
//                   active={pathname.startsWith("my-leaves")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/team-leaves"
//                   text="Team Leaves"
//                   icon={
//                     <Tooltip title="Leaves" placement="right-start">
//                       <DockOutlined className={classes.IconColor} />
//                     </Tooltip>
//                   }
//                   active={pathname.startsWith("team-leaves")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/holidays"
//                   text="Holidays"
//                   icon={
//                     <Tooltip title="Holidays" placement="right-start">
//                       <CalendarMonthOutlined className={classes.IconColor} />
//                     </Tooltip>
//                   }
//                   active={pathname.startsWith("holidays")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/resignation-request"
//                   text="Resignation Request"
//                   icon={
//                     <Tooltip
//                       title="Resignation Request"
//                       placement="right-start"
//                     >
//                       <RestorePageOutlined className={classes.IconColor} />
//                     </Tooltip>
//                   }
//                   active={pathname.startsWith("resignation-request")}
//                 />
//               </ListItemButton>
//               <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/appraisal"
//                   text="Appraisals"
//                   icon={
//                     <Tooltip title="Appraisals" placement="right-start">
//                       <RestorePageOutlined className={classes.IconColor} />
//                     </Tooltip>
//                   }
//                   active={pathname.startsWith("appraisal")}
//                 />
//               </ListItemButton>

//               {/* <ListItemButton className="dropdown-nav-custom-list">
//                 <CustomListItem
//                   to="/resignation-checklist"
//                   text="Resignation Checklist"
//                   icon={
//                     <Tooltip title="Resignation Accept" placement="right-start">
//                       <RestorePageOutlined className={classes.IconColor} />
//                     </Tooltip>
//                   }
//                   active={pathname.startsWith("resignation-checklist")}
//                 />
//               </ListItemButton> */}
//             </List>
//           </Collapse>
//           <CustomListItem
//             to="/customer"
//             text="Customers"
//             icon={<Hail className={classes.IconColor} />}
//             active={pathname.startsWith("/customer")}
//           />

//           <CustomListItem
//             to="/employees"
//             text="Employees"
//             icon={<WorkspacesIcon className={classes.IconColor} />}
//             active={pathname.startsWith("/employees")}
//           />

//           <CustomListItem
//             to="/profile"
//             text="Profile"
//             icon={<AccountCircle className={classes.IconColor} />}
//             active={pathname === "/profile"}
//           />
//           <CustomListItem
//             to="/reports"
//             text="Reports"
//             icon={<SummarizeIcon className={classes.IconColor} />}
//             active={pathname === "/reports"}
//           />
//           <CustomListItem
//             to="/resignation"
//             text="Exit Process"
//             icon={<AssignmentIndIcon className={classes.IconColor} />}
//             active={pathname === "/resignation"}
//           />
//           {user.appraisal_id && (
//             <CustomListItem
//               to="/my-appraisal"
//               text="My Appraisal"
//               icon={<FactCheckIcon className={classes.IconColor} />}
//               active={pathname === "/my-appraisal"}
//             />
//           )}
//         </>
//       );
//     case "Customer":
//       return (
//         <>
//           <CustomListItem
//             to="/"
//             text="Dashboard"
//             icon={<Home className={classes.IconColor} />}
//             active={pathname === "/"}
//           />
//           <CustomListItem
//             to="/ticket"
//             text="Tickets"
//             icon={<ConfirmationNumber className={classes.IconColor} />}
//             active={pathname.startsWith("/ticket")}
//           />

//           <CustomListItem
//             to="/subcustomer"
//             text="Sub Customers"
//             icon={<Hail className={classes.IconColor} />}
//             active={pathname.startsWith("/subcustomer")}
//           />

//           <CustomListItem
//             to="/profile"
//             text="Profile"
//             icon={<AccountCircle className={classes.IconColor} />}
//             active={pathname === "/profile"}
//           />
//           <CustomListItem
//             to="/reports"
//             text="Reports"
//             icon={<SummarizeIcon className={classes.IconColor} />}
//             active={pathname === "/reports"}
//           />
//         </>
//       );
//     case "Subcustomer":
//       return (
//         <>
//           <CustomListItem
//             to="/"
//             text="Dashboard"
//             icon={<Home className={classes.IconColor} />}
//             active={pathname === "/"}
//           />
//           <CustomListItem
//             to="/ticket"
//             text="Tickets"
//             icon={<ConfirmationNumber className={classes.IconColor} />}
//             active={pathname.startsWith("/ticket")}
//           />

//           <CustomListItem
//             to="/profile"
//             text="Profile"
//             icon={<AccountCircle className={classes.IconColor} />}
//             active={pathname === "/profile"}
//           />

//           <CustomListItem
//             to="/reports"
//             text="Reports"
//             icon={<SummarizeIcon className={classes.IconColor} />}
//             active={pathname === "/reports"}
//           />
//         </>
//       );

//     default:
//       return (
//         <>
//           <CustomListItem
//             to="/profile"
//             text="Profile"
//             icon={<AccountCircle className={classes.IconColor} />}
//             active={pathname === "/profile"}
//           />
//         </>
//       );
//   }
// }

import React, { Fragment, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Menu,
  MenuItem,
  Tooltip,
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
} from "@mui/material";
import {
  Menu as MenuIcon,
  LogoutOutlined,
  ConfirmationNumber,
  Work,
  Task,
  AccessTime,
  ShoppingCart,
  Hail,
  Workspaces,
  Storefront,
  AccountCircle,
  AssignmentInd,
  ExitToApp,
  FactCheck,
  Handshake,
  TrendingUp,
  DensityMedium,
  CalendarMonth,
  OfflinePin,
  DockOutlined,
  CalendarMonthOutlined,
  RestorePageOutlined,
  Category as CategoryIcon,
  AutoAwesomeMosaic as AutoAwesomeMosaicIcon,
  LibraryBooks as LibraryBooksIcon,
  FlagCircle as FlagCircleIcon,
  Person,
  ArrowDropDown ,
  Home,
  Summarize as SummarizeIcon,
  Dvr as DvrIcon,
  ExpandLess,
  ExpandMore,
} from "@mui/icons-material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../actions/auth";
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import { ListItemIcon, useMediaQuery } from "@material-ui/core";
import DomainAddIcon from '@mui/icons-material/DomainAdd';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
/**
 * Utility that returns a role‑based navigation tree.
 * Each node: { label, path?, icon, children?[] }
 */
function getNav(role, user) {
  const ticketingChildren = [
    { label: "Tickets", path: "/ticket", icon: <ConfirmationNumber /> },
    { label: "Reports", path: "/reports", icon: <SummarizeIcon /> },
  ];
  const projectChildren = [
    { label: "Timesheet", path: "/timesheet", icon: <Task /> },
    { label: "Projects", path: "/projects", icon: <Work /> },
    {
      label: "Project‑Activities",
      path: "/project-Activities",
      icon: <AccessTime />,
    },
    // {
    //   label: "Purchase Orders",
    //   path: "/purchase-orders",
    //   icon: <ShoppingCart />,
    // },
  ];

  /** HRMS dropdown shared between multiple roles */
  const hrmsChildren = [
    {
      label: "Working Status",
      path: "/working-status",
      icon: <CategoryIcon />,
    },
    { label: "My Leaves", path: "/my-leaves", icon: <OfflinePin /> },
    {
      label: "Team Leaves",
      path: "/team-leaves",
      icon: <DockOutlined />,
    },
    { label: "Holidays", path: "/holidays", icon: <CalendarMonthOutlined /> },
    {
      label: "Resignation Request",
      path: "/resignation-request",
      icon: <RestorePageOutlined />,
    },
    { label: "Appraisals", path: "/appraisal", icon: <ThumbUpIcon /> },
    { label: "PaySlip", path: "/Payslip-list", icon: <LibraryBooksIcon /> },
    { label: "KRA Goals", path: "/KRA-List", icon: <FlagCircleIcon /> },
  ];

  const assetChildren = [
    { label: "Assets", path: "/asset", icon: <CategoryIcon /> },
    {
      label: "Asset-Category",
      path: "/category",
      icon: <AutoAwesomeMosaicIcon />,
    },
  ];
  const sitesChildren = [
    { label: "Site Management", path: "/site-management", icon: <CategoryIcon /> },
    {
      label: "Sites",
      path: "/sites-contacts",
      icon: <AutoAwesomeMosaicIcon />,
    },
  ];
  
  const baseSingles = [
    // { label: "CRM", path: "/crmLeads", icon: <ConfirmationNumber /> },
    { label: "Customers", path: "/customer", icon: <Hail /> },
    { label: "Resources", path: "/employees", icon: <Workspaces /> },
    { label: "Vendors", path: "/vendor", icon: <Storefront /> },
    { label: "Profile", path: "/profile", icon: <AccountCircle /> },
  ];

  // Optional items
  const exitProcess = {
    // label: "Exit Process",
    // path: "/resignation",
    // icon: <AssignmentInd />,
  };
  const myAppraisal = {
    label: "My Appraisal",
    path: "/my-appraisal",
    icon: <FactCheck />,
  };

  /** Helper to decide Exit‑Process visibility for User role */
  const shouldShowExit = () => {
    if (role !== "User") return true;
    if (!user) return false;
    const lockDate = user.lock_in_date;
    if (!lockDate) return true;
    const now = new Date();
    const lock = new Date(lockDate.substring(0, 10));
    lock.setHours(0, 0, 0, 0);
    now.setHours(0, 0, 0, 0);
    return now >= lock;
  };

  switch (role) {
    case "Trial_User":
      return [
        { label: "Ticketing", icon: <ConfirmationNumber />, children: ticketingChildren },
        { label: "Project Management", icon: <Work />, children: projectChildren },
        ...baseSingles,
        ...(shouldShowExit() ? [exitProcess] : []),
        ...(user?.appraisal_id ? [myAppraisal] : []),
      ];

    case "Admin":
      return [
    { label: "Dashboard", path: "/", icon: <Home /> },
        // { label: "Ticketing", icon: <ConfirmationNumber />, children: ticketingChildren },
        { label: "Project Management", icon: <Work />, children: projectChildren },
        { label: "Site Management", icon: <DomainAddIcon />,  children: sitesChildren},
        { label: "Expenses Management", icon: <CurrencyExchangeIcon />, path: "/expenses-management" },
        { label: "Inventory List", icon: <DvrIcon />, path: "/inventory-list"  },
        { label: "Bills", icon: <DvrIcon />, path: "/bills"  },
        { label: "Purchase Order", icon: <DvrIcon />, path: "/purchase-orders"  },
        ...baseSingles,
        // { label: "Trial Users", path: "/trial-users", icon: <AccountCircle /> },
        exitProcess,
        ...(user?.appraisal_id ? [myAppraisal] : []),
      ];

    case "Partner":
      // Complex partner flow simplified: show Partner dropdown if verified
      const partnerChildren = [
        { label: "Leads", path: "/leads", icon: <DensityMedium /> },
        { label: "Follow‑up", path: "/followup", icon: <CalendarMonth /> },
        { label: "Sales", path: "/sales", icon: <TrendingUp /> },
      ];
      if (user?.agreement_status === "verified") {
        return [
          { label: "Profile", path: "/profile", icon: <AccountCircle /> },
          { label: "Partner", icon: <Handshake />, children: partnerChildren },
        ];
      }
      if (user?.agreement_status === "accept") {
        return [
          { label: "Partner", path: "/downloadUploadAgreement", icon: <ConfirmationNumber /> },
          { label: "Profile", path: "/profile", icon: <AccountCircle /> },
        ];
      }
      return [
        { label: "Partner", path: "/termsandconditions", icon: <ConfirmationNumber /> },
        { label: "Profile", path: "/profile", icon: <AccountCircle /> },
      ];

    case "User":
      return [
        { label: "Timesheet", path: "/timesheet", icon: <Task /> },
        { label: "Tickets", path: "/ticket", icon: <ConfirmationNumber /> },
        { label: "HRMS", icon: <ExitToApp />, children: hrmsChildren.filter((i) => !["Working Status", "Team Leaves", "Resignation Request", "Appraisals"].includes(i.label)) },
        { label: "Profile", path: "/profile", icon: <AccountCircle /> },
        ...(shouldShowExit() ? [exitProcess] : []),
        ...(user?.appraisal_id ? [myAppraisal] : []),
      ];

    case "Support":
      return [
        { label: "Dashboard", path: "/", icon: <Home /> },
        { label: "Tickets", path: "/ticket", icon: <ConfirmationNumber /> },
        { label: "Customers", path: "/customer", icon: <Person /> },
        { label: "Profile", path: "/profile", icon: <AccountCircle /> },
        { label: "Reports", path: "/reports", icon: <SummarizeIcon /> },
      ];

    case "ReportingManager":
      return [
        { label: "Dashboard", path: "/", icon: <Home /> },
        // { label: "Timesheet", path: "/timesheet", icon: <Task /> },
        { label: "Tickets", path: "/ticket", icon: <ConfirmationNumber /> },
        { label: "HRMS", icon: <ExitToApp />, children: hrmsChildren },
        { label: "Customers", path: "/customer", icon: <Hail /> },
        { label: "Employees", path: "/employees", icon: <Workspaces /> },
        { label: "Profile", path: "/profile", icon: <AccountCircle /> },
        { label: "Reports", path: "/reports", icon: <SummarizeIcon /> },
        exitProcess,
        ...(user?.appraisal_id ? [myAppraisal] : []),
      ];

    case "Customer":
      return [
        { label: "Dashboard", path: "/", icon: <Home /> },
        { label: "Tickets", path: "/ticket", icon: <ConfirmationNumber /> },
        { label: "Sub Customers", path: "/subcustomer", icon: <Hail /> },
        { label: "Profile", path: "/profile", icon: <AccountCircle /> },
        { label: "Reports", path: "/reports", icon: <SummarizeIcon /> },
      ];

    case "Subcustomer":
      return [
        { label: "Dashboard", path: "/", icon: <Home /> },
        { label: "Tickets", path: "/ticket", icon: <ConfirmationNumber /> },
        { label: "Profile", path: "/profile", icon: <AccountCircle /> },
        { label: "Reports", path: "/reports", icon: <SummarizeIcon /> },
      ];

    default:
      return [
        { label: "Profile", path: "/profile", icon: <AccountCircle /> },
      ];
  }
}

/** NavbarLayout: horizontally renders role‑based menus instead of a sidebar */
const NavbarLayout = ({ children }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const { pathname } = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile =  false;
  // Track which top‑level dropdown is open
  const [anchorEl, setAnchorEl] = useState({});
  const handleOpen = (label) => (event) => {
    setAnchorEl((prev) => ({ ...prev, [label]: event.currentTarget }));
  };
  const handleClose = (label) => () => {
    setAnchorEl((prev) => ({ ...prev, [label]: null }));
  };

  const navItems = getNav(user.role, user);

  return (
    <div className="flex flex-col min-h-screen">
      <AppBar position="static"  style={{backgroundColor:"#0920cb73",zoom:"0.8",position:"fixed",zIndex:"9999999999999999999999999999999999999999"}} className="bg-[#0920cb73] text-white shadow-md">
        <Toolbar style={{backgroundColor:"#0920cb73"}}  className="gap-2 min-h-[45px] w-full">
          {/* Logo */}
          <Box display="flex" alignItems="center" mr={2}>
            <img
              src="https://vastedge.com/api/myFile/vastedge-logo-white.png"
              alt="Company Logo"
              style={{ height: 41 }}
            />
          </Box>

          {/* Mobile Menu Icon */}
          {isMobile && (
            <IconButton onClick={() => setDrawerOpen(true)}>
              <MenuIcon sx={{ color: "white" }} />
            </IconButton>
          )}

          {/* Centered nav buttons for desktop */}
          {!isMobile && (
            <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center" ,zoom:".7"}}>
              {navItems.map((item) =>
                item.children ? (
                  <div key={item.label}>
                    <Button
                      onClick={handleOpen(item.label)}
                      style={{ color: "#fff", margin: "0 10px" }}
                      startIcon={item.icon}
                      endIcon={<ArrowDropDown />}
                      className={`normal-case hover:bg-[#273557] rounded-md ${
                        pathname.startsWith(item.path || "")
                          ? "bg-[#08459c] !text-[#fff]"
                          : ""
                      }`}
                    >
                      {item.label}
                    </Button>
                    <Menu
                      anchorEl={anchorEl[item.label]}
                      open={Boolean(anchorEl[item.label])}
                      onClose={handleClose(item.label)}
                      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                    >
                      {item.children.map((child) => (
                        <MenuItem
                          key={child.label}
                          component={RouterLink}
                          to={child.path}
                          onClick={handleClose(item.label)}
                          className="hover:bg-[#273557] text-[#fff] flex items-center"
                        >
                          <Box className="mr-2">{child.icon}</Box>
                          {child.label}
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>
                ) : (
                  <Button
                    key={item.label}
                    component={RouterLink}
                    to={item.path}
                    startIcon={item.icon}
                    style={{ color: "#fff", margin: "0 10px" }}
                    className={`normal-case hover:bg-[#273557] rounded-md ${
                      pathname === item.path ? "bg-[#08459c]" : ""
                    }`}
                  >
                    {item.label}
                  </Button>
                )
              )}
            </Box>
          )}

          {/* Logout button */}
          <Tooltip title="Logout">
            <IconButton onClick={() => dispatch(logout())}>
              <LogoutOutlined sx={{ color: "#fff" }} />
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>

      {/* Drawer for mobile */}
      <Drawer anchor="left" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <Box sx={{ width: 250 }} role="presentation">
          <List>
            {navItems.map((item) => (
              <Fragment key={item.label}>
                {item.children ? (
                  <>
                    <ListItemButton style={{zIndex:"9999999999999999999999999999999"}} className="" onClick={handleOpen(item.label)}>
                      <ListItemIcon>{item.icon}</ListItemIcon>
                      <ListItemText primary={item.label} />
                      {anchorEl[item.label] ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={Boolean(anchorEl[item.label])} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {item.children.map((child) => (
                          <ListItemButton
                            key={child.label}
                            sx={{ pl: 4 }}
                            component={RouterLink}
                            to={child.path}
                            onClick={() => setDrawerOpen(false)}
                          >
                            <ListItemIcon>{child.icon}</ListItemIcon>
                            <ListItemText primary={child.label} />
                          </ListItemButton>
                        ))}
                      </List>
                    </Collapse>
                  </>
                ) : (
                  <ListItemButton
                    component={RouterLink}
                    to={item.path}
                    onClick={() => setDrawerOpen(false)}
                  >
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText primary={item.label} />
                  </ListItemButton>
                )}
              </Fragment>
            ))}
          </List>
        </Box>
      </Drawer>

      {/* Page body */}
      <main  className="flex-1 overflow-y-auto bg-gray-100 p-4 mt-[55px]">{children}</main>
    </div>
  );
};

export default NavbarLayout;
